const INNITIAL_STATE = {
  permissions: [],
  explicit_permissions: null,
  group: "---",
  loading: true,
  updated: false
};

/** Retorna o estado atualizado */
export default function permission(state = INNITIAL_STATE, action) {
  switch (action.type) {
    case "PERMISSION_LOADING":
      return {
        ...state,
        loading: true
      };
    case "PERMISSION_OK":
      return {
        ...state,
        loading: false,
        permissions: action.permissions,
        explicit_permissions: action.explicit_permissions,
        group: action.group,
        updated: true
      };
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/permission.js